import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Translate } from 'react-localize-redux';
import {
  BottomNavigation, BottomNavigationAction, Hidden,
  Paper, Grid, Switch, Typography, FormControlLabel,
} from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import MapIcon from '@material-ui/icons/Map';
import ListIcon from '@material-ui/icons/List';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { connect } from 'react-redux';
import { submit } from '../components/submit/submit.actions';
import Map from '../components/map';
import ListMobile from '../components/list-mobile';
import StyledTable from '../components/table/styled-table';
import CustomTableRow from '../components/table/custom-table-row';
import CustomTableCell from '../components/table/custom-table-cell';
import {
  getControllersListCommaSep, formatDatePeriod, getWorkPlanFromAssignmentList,
  getLicenseListFromLicenseSysIDs, sortByNewestFromTime, isDateStrInPast,
} from '../utils';
import LicenseListDesktop from '../components/license-list-desktop';
import LicenseListMobile from '../components/license-list-mobile';

class MapView extends Component {
  constructor(props) {
    super(props);

    const {
      assignments: { payload: assignments },
    } = this.props;

    const hasAnyFutureAssignments = assignments.some(
      assignment => !isDateStrInPast(assignment.toDate),
    );

    this.state = {
      value: 0,
      // If user has got only past assignments, show them by default
      showHistoricAssignments: !hasAnyFutureAssignments,
    };
  }

  render() {
    const {
      classes, history,
      licenses: { payload: licenses },
      assignments: { payload: assignments },
      activeWorkPlan, mapOptions,
    } = this.props;

    const workPlanId = activeWorkPlan ? activeWorkPlan.sysId : '';
    const showWorkPlanLicenses = mapOptions && mapOptions.showWorkPlanLicenses;

    const workPlan = showWorkPlanLicenses
      ? getWorkPlanFromAssignmentList(assignments, workPlanId) : null;

    const workPlanLicenseSysIDs = workPlan != null ? workPlan.licensesSysId : null;
    const licensesFiltered = showWorkPlanLicenses
      ? getLicenseListFromLicenseSysIDs(licenses, workPlanLicenseSysIDs) : licenses;

    const { value, showHistoricAssignments } = this.state;
    const { dispatch } = this.props;

    const anyAssignments = assignments && assignments.length > 0;

    return (
      <div className={classes.container}>
        {value !== 2 && (
          <Grid container alignItems="center" spacing={1}>
            <Grid item className={classes.switch}>
              <FormControlLabel
                control={(
                  <Switch
                    checked={showWorkPlanLicenses}
                    onChange={(e) => {
                      dispatch(submit({ showWorkPlanLicenses: e.target.checked }, 'mapOptions'));
                    }}
                    name="showWorkPlanLicenses"
                    color="primary"
                  />
                )}
                label="Vis aktiv arbeidsplan"
              />
            </Grid>
          </Grid>
        )}
        {showWorkPlanLicenses && workPlanId === '' && value !== 2 && (
          <Typography className={classes.noActiveWorkPlanMsg}>
            <strong>Du har ikke valgt en aktiv arbeidsplan ennå.</strong>
          </Typography>
        )}
        {value === 0 && [
          <div
            key="map"
            className={clsx(classes.map, value !== 0 ? classes.hide : '',
              window.innerWidth > 1280 ? classes.desktopMap : classes.mobileMap)}
          >
            <Map
              licenses={licensesFiltered}
              showWorkPlanLicenses={showWorkPlanLicenses}
              workPlan={workPlan}
            />
          </div>,
          <Hidden key="licenses-list" mdDown>
            <Paper className={clsx(classes.paper, classes.margin, classes.marginTop)} elevation={0}>
              <LicenseListDesktop
                licenses={licensesFiltered}
                showIsControlCompleted={showWorkPlanLicenses}
                workPlan={workPlan}
              />
            </Paper>
            <Typography className={classes.marginTop} variant="h5">
              Kontrolloppdrag og arbeidsplaner
            </Typography>
            <Paper className={clsx(classes.paper, classes.margin)} elevation={0}>
              {!anyAssignments && (
                <Typography>Ingen tilgjengelige kontrolloppdrag</Typography>
              )}
              {anyAssignments && (
                <>
                  <FormControlLabel
                    control={(
                      <Switch
                        checked={showHistoricAssignments}
                        onChange={(e) => {
                          this.setState({ showHistoricAssignments: e.target.checked });
                        }}
                        name="showHistoricAssignments"
                        color="primary"
                      />
                    )}
                    label="Vis også historiske kontrolloppdrag"
                  />
                  <StyledTable
                    header={[
                      <Translate id="assignment.titleControlList" />,
                      <Translate id="assignment.zone" />,
                      <Translate id="assignment.assigned" />,
                      <Translate id="assignment.period" />,
                      <Translate id="assignment.numberOfLicenses" />,
                      '',
                    ]}
                    rowsPerPage={10}
                  >
                    {assignments.sort(sortByNewestFromTime).map((assignment, index) => {
                      if (!showHistoricAssignments && isDateStrInPast(assignment.toDate)) {
                        return ''; // Skip showing this assignment, it's only shown if user chooses to view historic assignments
                      }
                      return (
                        <CustomTableRow
                          key={assignment.sysId}
                          link={`oppdrag--${assignment.sysId}`}
                          odd={!(index % 2)}
                        >
                          <CustomTableCell>{assignment.controlList.name}</CustomTableCell>
                          <CustomTableCell>
                            {(assignment.controlList.zone
                              && assignment.controlList.zone.indexOf('sone') === 0)
                              ? assignment.controlList.zone.substring(4)
                              : assignment.controlList.zone}

                          </CustomTableCell>
                          <CustomTableCell>
                            {getControllersListCommaSep(assignment.controllers)}
                          </CustomTableCell>
                          <CustomTableCell>
                            {formatDatePeriod(assignment.fromDate, assignment.toDate)}
                          </CustomTableCell>
                          <CustomTableCell>
                            {assignment.controlList.licenses.length}
                          </CustomTableCell>
                          <CustomTableCell shrink>
                            <ArrowForwardIcon color="primary" />
                          </CustomTableCell>
                        </CustomTableRow>
                      );
                    })}
                  </StyledTable>
                </>
              )}
            </Paper>
          </Hidden>,
        ]}
        {value === 1 && (
          <Paper className={classes.paper} elevation={0}>
            <LicenseListMobile
              licenses={licensesFiltered}
              showIsControlCompleted={showWorkPlanLicenses}
              workPlan={workPlan}
            />
          </Paper>
        )}
        {value === 2 && (
          <Paper className={clsx(classes.paper, classes.marginTop)} elevation={0}>
            {!anyAssignments && (
              <Typography>Ingen tilgjengelige kontrolloppdrag</Typography>
            )}
            {anyAssignments && (
              <>
                <FormControlLabel
                  control={(
                    <Switch
                      checked={showHistoricAssignments}
                      onChange={(e) => {
                        this.setState({ showHistoricAssignments: e.target.checked });
                      }}
                      name="showHistoricAssignments"
                      color="primary"
                    />
                  )}
                  label="Vis også historiske kontrolloppdrag"
                />
                <ListMobile
                  fetched
                  rowsPerPage={5}
                  content={assignments && assignments.sort(
                    sortByNewestFromTime,
                  ).map((assignment) => {
                    if (!showHistoricAssignments && isDateStrInPast(assignment.toDate)) {
                      return ''; // Skip showing this assignment, it's only shown if user chooses to view historic assignments
                    }

                    let controllers = '';
                    assignment.controllers.forEach((controller) => {
                      if (controllers !== '') controllers += ', ';
                      controllers += `${controller.firstName} ${controller.lastName} (${controller.controllerNumber})`;
                    });

                    return {
                      sysId: assignment.sysId,
                      primary: assignment.controlList.name,
                      secondary: (
                        <>
                          <Typography component="span" variant="body1" display="block">
                            {`Sone: ${(assignment.controlList.zone
                              && assignment.controlList.zone.indexOf('sone') === 0)
                              ? assignment.controlList.zone.substring(4)
                              : assignment.controlList.zone}`}
                          </Typography>
                          <Typography component="span" variant="body1" display="block">
                            {`Tildelt: ${controllers}`}
                          </Typography>
                          <Typography component="span" variant="body1" display="block">
                            {`Periode: ${formatDatePeriod(assignment.fromDate, assignment.toDate)}`}
                          </Typography>
                          <Typography component="span" variant="body1" display="block">
                            {`Antall bevillinger: ${assignment.controlList.licenses.length}`}
                          </Typography>
                        </>
                      ),
                      onClick: () => history.push(`/oppdrag--${assignment.sysId}`),
                    };
                  })}
                />
              </>
            )}
          </Paper>
        )}
        <Hidden lgUp>
          <BottomNavigation
            value={value}
            onChange={(event, newValue) => {
              this.setState({ value: newValue });
            }}
            showLabels
            className={classes.bottomNav}
          >
            <BottomNavigationAction label="Kart" icon={<MapIcon />} />
            <BottomNavigationAction label="Liste" icon={<ListIcon />} />
            <BottomNavigationAction label="Oppdrag" icon={<AssignmentIcon />} />
          </BottomNavigation>
        </Hidden>
      </div>
    );
  }
}

MapView.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  licenses: PropTypes.object.isRequired,
  assignments: PropTypes.object.isRequired,
  activeWorkPlan: PropTypes.object,
  mapOptions: PropTypes.object,
};

MapView.defaultProps = {
  activeWorkPlan: null,
  mapOptions: null,
};

const styles = theme => ({
  container: {
    minHeight: '15rem',
  },
  map: {
    width: 'calc(100% + 1.2rem)',
    marginLeft: '-0.6rem',
  },
  desktopMap: {
    height: '60vh',
  },
  mobileMap: {
    height: 'calc(100vh - 10rem)',
  },
  bottomNav: {
    bottom: 0,
    width: '100%',
    position: 'fixed',
    marginLeft: '-0.6rem',
    backgroundColor: theme.palette.background.default,
    borderTop: '0.0625rem solid #cccccc',
  },
  hide: {
    display: 'none',
  },
  paper: {
    padding: '0.8rem',
    paddingBottom: 0,
    border: '1px solid lightgray',
  },
  switch: {
    marginLeft: 'auto',
  },
  noActiveWorkPlanMsg: {
    textAlign: 'right',
    margin: '.5rem 0',
  },
  margin: {
    margin: '1rem 0',
  },
  marginTop: {
    marginTop: '3rem',
  },
});

const mapStateToProps = ({
  licenses,
  assignments,
  form: {
    activeWorkPlan,
    mapOptions,
  },
}) => ({
  licenses,
  assignments,
  activeWorkPlan,
  mapOptions,
});


export default connect(mapStateToProps)(withStyles(styles)(withRouter(MapView)));
